<template>
    <div class="journey-step-contacts-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Contacts in: {{ stepName }}</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <journey-email-step-contacts-board 
                    v-if="this.stepType === 'Email Step'"
                   :stepId="this.journeyStepId" />
                <journey-step-contacts-board
                    v-else
                   :stepId="this.journeyStepId" />
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="transparent-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button class="save-btn" @click="closeWidget()">
                        Done
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const JourneyEmailStepContactsBoard = () => import('@/components/journey/journey-email-step-contacts-board');
const JourneyStepContactsBoard = () => import('@/components/journey/journey-step-contacts-board');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'journey-step-contacts-widget',

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'journey-email-step-contacts-board': JourneyEmailStepContactsBoard,
        'journey-step-contacts-board': JourneyStepContactsBoard
    },

    data() {
        return {
            stepName: null,
            stepType: null,
            journeyStepId: this.widget.journeyStepId,
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        getStepName() {
            var query = `/service/JourneySteps?$filter=Id eq ${ this.journeyStepId }&$select=Name,JourneyStepTypeId`;

            this.$api
                .get(query)
                .then(response => {
                    this.stepName = response.data.value[0].Name || this.getTypeById(response.data.value[0].JourneyStepTypeId);
                    this.stepType = this.getTypeById(response.data.value[0].JourneyStepTypeId);
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred while fetching your Step Name.', { error });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getTypeById(id) {
            switch(id) {
                case 1:
                    return 'Delay Step';
                case 2:
                    return 'Email Step';
                case 3:
                    return 'Condition Step';
                default:
                    return null;
            }
        }
    },

    created() {
        this.getStepName();
    }
}
</script>

<style>
.journey-step-contacts-widget .action-container {
    display: flex;
}

.journey-step-contacts-widget .action-container .btn {
    margin-left: 15px;
}

.journey-step-contacts-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.journey-step-contacts-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.journey-step-contacts-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}
</style>